import { useEffect } from "react";
import { useUiStore } from "../stores/uiStore";
import { useOrgStore } from "../stores/orgStore";
import { useJobs } from "../stores/jobBus";
import { useFieldJobs } from "./queries";

export { useJobs };

// Job progress comes from polling the field's jobs. The socket and its ticket are gone.
export function useJobTracker(enabled = true) {
  const selectedFieldId = useUiStore((s) => s.selectedFieldId);
  const activeOrgId = useOrgStore((s) => s.activeOrgId);
  const { data } = useFieldJobs(enabled ? selectedFieldId : null);

  useEffect(() => {
    if (!data) return;
    const active = new Set<string>();
    for (const job of data) {
      if (
        job.status !== "in_progress" &&
        job.status !== "waiting" &&
        job.status !== "blocked"
      ) {
        continue;
      }
      active.add(job.job_id);
      useJobs.getState().upsert({
        job_id: job.job_id,
        pct: job.status === "in_progress" ? 50 : 0,
        message: job.process_name || job.process_id,
        status: "running",
      });
    }
    for (const id of Object.keys(useJobs.getState().jobs)) {
      if (!active.has(id)) useJobs.getState().clear(id);
    }
  }, [data, selectedFieldId, activeOrgId]);
}
